module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/wfft_1x.651615c.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/wfft_1x.png
// module id = nIL0
// module chunks = 41